var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sequra-push"},[_c('div',{staticClass:"sequra-promotion-widget",attrs:{"data-amount":_vm.price.replace('.', ''),"data-product":"pp3","data-size":"L","data-type":"banner","data-branding":"black"}})])}
var staticRenderFns = []

export { render, staticRenderFns }